import { toast } from "react-hot-toast";
import Remote from "../services/network";

export const getLatestSubscriptions = async () => {
  try {
    const data = await Remote.get("/orders/latest-subscription-orders");
    return data?.data?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
